import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.UsefulResources = class UsefulResources extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-useful-resources';
	}

	constructor(element) {
		super(element);
	}

	setVars() {
		this.$expandButton = this.$element.find('.resources__load-more');
		this.$resources = this.$element.find('.single-resource');
		this.$resourcesList = this.$element.find('.resources__list');
		this.resourcesLength = this.$resources.length;
		this.$amountSpan = this.$expandButton.find('.amount');
		this.$expandButtonCopy = this.$expandButton.find('.copy');
	}

	addEventListeners() {
		this.$expandButton.on('click', this.onExpandButtonClick.bind(this));
	}

	onExpandButtonClick() {
		this.expanded = !this.expanded;

		if (this.expanded) {
			this.$resourcesList.css('height', this.totalHeight);
			this.$amountSpan.text('');
			this.$expandButtonCopy.text('collapse');
		} else {
			this.$resourcesList.css('height', this.collapseHeight);
			this.$amountSpan.text(this.extrasLength);
			this.$expandButtonCopy.text('more files');
		}

		this.$element.toggleClass('expanded', this.expanded);
	}

	showExpandButton() {
		this.expanded = false;
		this.$expandButton.addClass('active');
		this.$amountSpan.text(this.extrasLength);
	}

	calculateComponentHeight() {
		this.totalHeight = this.$resourcesList.height();
		this.extrasLength = this.resourcesLength - 3;
		this.collapseHeight = this.calculateCollapseHeight();
		this.$resourcesList.css('height', this.collapseHeight);
	}

	calculateCollapseHeight() {
		let total = 0;

		this.$resources.slice(0, 3).each((index, item) => {
			const amount = $(item).height();

			total += amount;
		});

		return total + 3;
	}

	render() {
		this.setVars();

		if (this.resourcesLength > 3) {
			this.calculateComponentHeight();
			this.showExpandButton();
			this.addEventListeners();
		}
	}
};



// WEBPACK FOOTER //
// ./components/usefulResources/scripts/usefulResources.js